import script from './SeoCopyBlock.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"seoContentElement",staticClass:"seo-content",class:{
            expanded: _vm.isExpanded,
            collapsed: _vm.isOverflowing && !_vm.isExpanded,
        },domProps:{"innerHTML":_vm._s(_vm.sanitizedCopy)}}),_vm._v(" "),(_vm.isOverflowing)?_c('SdsButton',{staticClass:"seo-content__button",attrs:{"background":"elevation","variant":"secondary","size":"md"},on:{"click":_vm.onToggleButtonClick}},[_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(_vm.$t(_vm.toggleButtonText)))])]):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-159d8b90_0", { source: ".seo-content__button{width:100%}.seo-content{overflow:hidden;text-overflow:ellipsis}.seo-content.expanded{height:auto}.seo-content.collapsed{max-height:180px;position:relative}.seo-content.collapsed::after{content:\"\";position:absolute;bottom:0;left:0;width:100%;height:40px;background:linear-gradient(to bottom,var(--gradients-body-transparent),var(--system-bg-elevation-body));pointer-events:none}.seo-content h2,.seo-content h3,.seo-content h4{margin:16px 0 4px 0;color:var(--system-text-on-elevation-primary);font-family:var(--system-body-default-family, \"Inter\", sans-serif);font-size:var(--system-body-default-size);font-weight:600;line-height:var(--system-body-default-line-height);letter-spacing:var(--system-body-default-letter-spacing)}.seo-content li,.seo-content p{margin:0;color:var(--system-text-on-elevation-tertiary-on-body);font-family:var(--system-body-default-family, \"Inter\", sans-serif);font-size:var(--system-body-default-size);font-weight:400;line-height:var(--system-body-default-line-height);letter-spacing:var(--system-body-default-letter-spacing)}.seo-content blockquote{color:var(--system-text-on-elevation-tertiary-on-body);font-family:var(--system-body-default-family, \"Inter\", sans-serif);font-size:var(--system-body-default-size);font-weight:400;line-height:var(--system-body-default-line-height);letter-spacing:var(--system-body-default-letter-spacing)}.seo-content ul{list-style-type:unset;list-style-position:inside}.seo-content a{color:var(--system-text-on-elevation-link);font-family:var(--system-body-default-family, \"Inter\", sans-serif);font-size:var(--system-body-default-size);font-weight:600;line-height:var(--system-body-default-line-height);letter-spacing:var(--system-body-default-letter-spacing)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
